import { useCallback, useEffect } from "react";

import { APIProvider, Map, MapMouseEvent } from "@vis.gl/react-google-maps";
import LocationsLayer from "./components/LocationsLayer";
import MapNavigation from "./components/Navigation";
import RoutesLayer from "./components/RoutesLayer";
import { useNitroStore } from "../../store/Store";
import Popup from "./components/popup";
import SelectedLocation from "./components/SelectedLocation";
import NitroService from "../../utils/nitro.service";
import Zoom from "./components/Zoom";
import HidePinsPopup from "../../panels/hidePins";
import { IPinExtension } from "../../types/ILocation";

const NitroMap = ({ locations }: { locations: IPinExtension[] }) => {
  const [
    isLoading,
    mapApiKey,
    setMapApiKey,
    mapType,
    showMapPopup,
    setShowMapPopup,
    setSelectedLocation,
    setPinLocation,
    selectingPinLocation,
    multiLocationDestinations,
    product,
    showHidePinsPopup,
  ] = useNitroStore((state) => [
    state.isLoading,
    state.mapApiKey,
    state.setMapApiKey,
    state.mapType,
    state.showMapPopup,
    state.setShowMapPopup,
    state.setSelectedLocation,
    state.setPinLocation,
    state.selectingPinLocation,
    state.multiLocationDestinations,
    state.product,
    state.showHidePinsPopup,
  ]);

  const getKey = useCallback(async () => {
    try {
      if (isLoading) return;
      const result = await NitroService.mapEndpoint();
      setMapApiKey(result.apiKey);
    } catch (err) {
      console.error(err);
    }
  }, [isLoading, setMapApiKey]);

  useEffect(() => {
    if (!mapApiKey) {
      getKey();
    }
  }, [isLoading, mapApiKey, setMapApiKey, getKey]);

  const handleMapClick = useCallback(
    (e: MapMouseEvent) => {
      if (!selectingPinLocation && showMapPopup) {
        console.log("Close popup, clear selected location");
        setShowMapPopup(false);
        setSelectedLocation(undefined);
      }
      if (selectingPinLocation) {
        console.log("Set pin location", e.detail.latLng);
        setPinLocation(e.detail.latLng as any);
      }
    },
    [
      showMapPopup,
      setShowMapPopup,
      selectingPinLocation,
      setSelectedLocation,
      setPinLocation,
    ],
  );

  if (!mapApiKey) {
    return null;
  }

  return (
    <div
      style={{
        height: "100%",
      }}
    >
      {multiLocationDestinations.filter(
        (d) =>
          !d.availableProducts.includes(product) &&
          d.destination.pinType !== "city",
      ).length > 0 &&
        showHidePinsPopup && <HidePinsPopup />}
      <APIProvider apiKey={mapApiKey}>
        <Map
          id="primarymap"
          style={{
            height: "100%",
            width: "100%",
          }}
          mapId="7f63f0984301bed3"
          onClick={handleMapClick}
          mapTypeId={mapType}
          mapTypeControl={false}
          gestureHandling="greedy"
          disableDefaultUI
          maxZoom={20}
          minZoom={5}
          clickableIcons={false}
          defaultCenter={{
            lat: 40,
            lng: -98,
          }}
          defaultZoom={5}
        >
          <LocationsLayer locations={locations} />
          <RoutesLayer />
          <MapNavigation />
          <Popup />
          <SelectedLocation />
          <Zoom />
        </Map>
      </APIProvider>
    </div>
  );
};

export default NitroMap;
